<div class="header-layout">
  <div class="left-container">
    <div (click)="toggleNavigation()" class="menu">
      <app-icon [appId]="AppIdsEnum.header_hamburger" [svgIcon]="IconsEnum.menu_expanded"></app-icon>
    </div>
      <a class="logo-container" [routerLink]="routes.overview">
          <div [appId]="AppIdsEnum.header_logo" class="logo"></div>
      </a>
      <app-icp-em-tag></app-icp-em-tag>
    <span class="separator"></span>
    <app-em-breadcrumbs></app-em-breadcrumbs>
  </div>
  <div class="right-container">
    <app-dark-mode-toggle></app-dark-mode-toggle>
    <div class="time-indication body-regular">
      <app-clock [appId]="AppIdsEnum.header_clock_time" [format]="clockFormat"></app-clock>
      <app-icon [svgIcon]="IconsEnum.dot"></app-icon>
      <app-clock [appId]="AppIdsEnum.header_clock_date" [format]="fullDateFormat" class="g-light"></app-clock>
    </div>
    <div class="header-icons">
      <app-pcap-player-indicator></app-pcap-player-indicator>
      @if ((!iemService.isIem) || iemService.isIcpViewInEm()) {
        <app-ui-header-icon [icon]="IconsEnum.passive_monitoring" [isDisabled]="(passiveConsumptionValue$ | async) === false"
                            [tooltip]="passiveConsumptionTooltipTexts" [isClickable]="false">
        </app-ui-header-icon>
      }

          @if (activeQueriesIsReady && !iemService.isIem) {
              <app-ui-header-icon [icon]="IconsEnum.active_query"
                                  [isDisabled]="activeQueriesService.isGlobalPauseOn"
                                  [tooltip]="resolveActiveQueriesIconTooltip()" [isClickable]="false">
              </app-ui-header-icon>
          }
      </div>

      <app-ui-header-icon [icon]="IconsEnum.help" [isDisabled]="isDisabledPendo()" [tooltip]="pendoTooltipTexts" [isClickable]="true"
                          [appId]="AppIdsEnum.header_help">
      </app-ui-header-icon>

      <div class="username">
          <app-header-flyout (selected)="onHeaderFlyoutChange($event)" [settings]="headerFlyoutSettings"></app-header-flyout>
      </div>
  </div>
</div>
